export default __webpack_public_path__ + "static/media/app-bar-save.8ed65dc6.svg";